import styled from 'styled-components'

export const StyledBusinessLayout = styled.div`
  position: relative;
  font-family: Outfit;
  min-height: 100vh;
  @media (min-width: 768px) {
    display: flex;
  }
`

export const GenericDisplayFlex = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  ${(props) => props?.sb && 'justify-content: space-between;'};
  ${(props) => props?.center && 'justify-content: center;'};

  @media (max-width: 599px) {
    flex-direction: column;
    align-items: flex-start;
    ${(props) => props?.sb && 'justify-content: flex-start;'};
  }
`

export const GenericDisplayFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  ${(props) => props?.aic && 'align-items: center;'};
  ${(props) => props?.jcc && 'justify-content: center;'};
`
